import { axiosInstance } from '@/http-common'

/**
 * Get list of Modbus assets accessible by the current user
 */
export async function getModbusAssetsList(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/modbus/assets-list')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get all available CAN/Modbus IO parameters
 */
export async function getCanParamsIo(): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/can_params_io')
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get the write status of a pending Modbus parameter set command
 * @param serialNumber - Asset serial number
 */
export async function getModbusParamSetStatus(serialNumber: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/modbus/param-set-status/${serialNumber}`)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get the Modbus read-back frame hex string for a given asset param
 * @param serialNumber - Asset serial number
 * @param paramName - Parameter name
 */
export async function getModbusParamReadFrame(serialNumber: string, paramName: string): Promise<any> {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/api/v1/modbus/param-read-frame', {
      params: { serial_number: serialNumber, param_name: paramName }
    })
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}

/**
 * Get DKN control panel action definitions for an asset
 * @param serialNumber - Asset serial number
 */
export async function getDknControlPanel(serialNumber: string): Promise<any> {
  return axiosInstance.get(`/api/v1/dkn/control-panel/${encodeURIComponent(serialNumber)}`)
}

/**
 * Get the latest value of a Modbus param for an asset from the database
 * (asset_params_data). Used to display read-only params in the client panel
 * — wartość pochodzi z cyklicznego odczytu serwera teltonika, nie z bezpośredniego
 * zapytania do urządzenia.
 *
 * @param serialNumber - Asset serial number
 * @param paramName - Parameter name (e.g. DKN_UART_D10_DEFROST_OPERATION_C304_O1_B1)
 */
export async function getModbusParamLatestValue(serialNumber: string, paramName: string): Promise<any> {
  return axiosInstance.get('/api/v1/modbus/param-latest-value', {
    params: { serial_number: serialNumber, param_name: paramName }
  })
}

/**
 * Get the result of a serial command sent to a device via Redis
 * @param imei - Device IMEI
 */
export async function getDeviceSerialCommandResult(imei: string): Promise<string | null> {
  return new Promise((resolve, reject) => {
    axiosInstance.get(`/api/v1/redis/serial_result/${imei}`)
      .then(response => {
        const result = response?.data?.result
        resolve((result === null || result === undefined || result === '') ? null : String(result))
      })
      .catch(error => reject(error))
  })
}
